module.exports = __webpack_public_path__ + "img/edit.65832571.png";